import angular from 'angular';
import relatedPartySupplier from './relatedPartySupplier';

export default angular
  .module('components.relatedPartySupplier', [])
  .component('relatedPartySupplier', relatedPartySupplier).name;
